import styles from "./EditTimeline.module.css";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { isEqual } from "lodash";
import { usePrevious } from "../../../components/function/usePrevious";
import {
    getTimeline,
    // UpdateTimelineClipList,
    UpdateTimelinePlayInfo,
    UpdateTimelineStatus,
} from "../../store/actions/TimelineActions";
import { AppState } from "../../../root/RootReducer";
import TimelineDirectory from "./TimelineDirectory";
import { Link, useRouteMatch } from "react-router-dom";
import ExportVideo from "./ExportVideo";
import { TimelineVideoPlayer } from "./TimelineVideoPlayer";
import { Button, CircularProgress } from "@material-ui/core";
// import { Clip } from "../../models/Timeline";
// import PlayIcon from "../../../assets/image/play02.svg";
// import RewindIcon from "../../../assets/image/fastrewind01.svg";
// import FastForwardIcon from "../../../assets/image/fastrewind02.svg";
// import PauseIcon from "../../../assets/image/pause.svg";
// import BeforeIcon from "../../../assets/image/before02.svg";
// import NextIcon from "../../../assets/image/next02.svg";
// import SearchIcon from "../../../assets/image/search.svg";
// import RedoIcon from "../../../assets/image/redo.svg";
// import UndoIcon from "../../../assets/image/back.svg";
import ArrowIcon from "../../../assets/icon/ArrowIcon";
import { useInitFlag } from "../../../components/function/useInitFlag";
import PuiMessage from "../../../components/widgets/PuiMessage";
import { GetClipTimesFromCliplist, GetTotalTimeFromClipList } from "../../../utils/TimelineUtils";
import PuiTypography from "../../../components/elements/PuiTypography";
import Error from "../../../root/components/layout/Error";
import { Clip } from "../../models/Timeline";

/**
|--------------------------------------------------
| タイムライン編集画面
|--------------------------------------------------
*/
const maxHistory = 30;

export default function EditTimeline() {
    const dispatch = useDispatch();
    const match = useRouteMatch<{ id: string }>();
    const timelineId = match.params.id;
    const {
        // user,
        currentTime,
        timeline,
        clipList,
        isTimelineLoading,
        isLoading,
        isFailedGetTimeline,
        isChangeClipListHistory,
    } = useSelector((state: AppState) => ({
        // user: state.user.user,
        currentTime: state.timeline.timelinePlayInfo.currentTime,
        timeline: state.timeline.timeline?.timeline,
        clipList: state.timeline.timeline?.clipList,
        isLoading: state.timeline.isLoading,
        isTimelineLoading: state.timeline.isLoading,
        isFailedGetTimeline: state.timeline.isFailedGetTimeline,
        isChangeClipListHistory: state.timeline.isChangeClipListHistory,
    }));

    const previousIsChangeClipListHistory = usePrevious(isChangeClipListHistory);

    const isCreating = timeline?.status === "CREATING" ? true : false;
    const [isCreatingVideo, setIsCreatingVideo] = useState(isCreating);
    const [clipListHistory, setClipListHistory] = useState<Clip[][]>([]);
    const [currentClipListIndex, setCurrentClipListIndex] = useState<number>(0);

    // 書き出し失敗・完了メッセージ
    const [showExportErrorMessage, setShowExportErrorMessage] = useInitFlag();
    const [showExportSuccessMessage, setShowExportSuccessMessage] = useInitFlag();

    // メッセージを閉じる
    const closeExportSuccessMsg = () => {
        setShowExportSuccessMessage(false);
    };

    const closeExportErrorMsg = () => {
        setShowExportErrorMessage(false);
    };

    // 書き出しをキャンセルする
    const handleCancelButton = () => {
        if (timeline) {
            dispatch(UpdateTimelineStatus(timeline?.id, "CREATE_CANCELING"));
            setIsCreatingVideo(false);
        }
    };

    // タイムライン操作のUNDO
    // const handleUndoButton = () => {
    //     if (clipListHistory.length > 1 && currentClipListIndex > 0) {
    // dispatch(
    //     UpdateTimelineClipList(
    //         Number(timelineId),
    //         Number(user?.id),
    //         clipListHistory[currentClipListIndex - 1]
    //     )
    // );
    //         setCurrentClipListIndex((prevIndex) => prevIndex - 1);
    //     }
    // };

    // タイムライン操作のREDO
    // const handleRedoButton = () => {
    //     if (clipListHistory.length > 1 && currentClipListIndex < clipListHistory.length - 1) {
    // dispatch(
    //     UpdateTimelineClipList(
    //         Number(timelineId),
    //         Number(user?.id),
    //                 clipListHistory[currentClipListIndex + 1]
    //             )
    //         );
    //         setCurrentClipListIndex((prevIndex) => prevIndex + 1);
    //     }
    // };

    // クリップが切り替わるたびに実行する
    useEffect(() => {
        // クリップが切り替わるたびにTimelinePlayInfoを更新する
        if (clipList !== undefined && clipList.length !== 0) {
            const sourceLength = clipList.length;
            const timelineTotalTime = GetTotalTimeFromClipList(clipList);
            const timelineClipTimes = GetClipTimesFromCliplist(clipList);
            dispatch(
                UpdateTimelinePlayInfo(
                    currentTime,
                    timelineTotalTime,
                    sourceLength,
                    timelineClipTimes
                )
            );
        }
        // eslint-disable-next-line
    }, [clipList]);

    // 書き出し状況取得と完了メッセージ表示
    useEffect(() => {
        let timerGetTimeline: NodeJS.Timeout;
        if (isCreatingVideo && !isTimelineLoading) {
            if (
                timeline?.id &&
                timeline?.status &&
                (timeline.status?.toLocaleLowerCase() === "creating" ||
                    timeline.status?.toLocaleLowerCase() === "is_editing")
            ) {
                timerGetTimeline = setTimeout(() => dispatch(getTimeline(timeline.id)), 5000);
            } else if (
                timeline?.id &&
                timeline?.status &&
                timeline.status.toLocaleLowerCase() === "error"
            ) {
                setShowExportErrorMessage(true);
            } else if (
                timeline?.id &&
                timeline?.status &&
                timeline.status.toLocaleLowerCase() === "created"
            ) {
                setShowExportSuccessMessage(true);
            }
        }

        // クリーンアップ
        return () => {
            clearTimeout(timerGetTimeline);
        };
        // eslint-disable-next-line
    }, [isTimelineLoading, isCreatingVideo]);

    useEffect(() => {
        if (isCreatingVideo && (showExportErrorMessage || showExportSuccessMessage)) {
            setIsCreatingVideo(false);
        }
        // eslint-disable-next-line
    }, [showExportErrorMessage, showExportSuccessMessage]);

    // コンポーネントがレンダリング後に一度だけ実行される
    useEffect(() => {
        setClipListHistory([]);
        setCurrentClipListIndex(0);

        // タイムラインの情報を取得
        if (Number(timelineId)) {
            dispatch(getTimeline(Number(timelineId)));

            // 「書き出し中」かどうか
            const isCreating = timeline?.status === "CREATING" ? true : false;
            setIsCreatingVideo(isCreating);
        }

        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        // console.log("clipList changed user:",user,"timeline",timeline);
        // if (!user || !timeline || !clipList || clipList.length === 0) return;
        if (!timeline || !clipList) return;

        // console.log("---------------------------\n");
        if (previousIsChangeClipListHistory === undefined) {
            // console.log("page nav wait init\n");
            return;
        }
        // console.log(" clip length",clipList.length,"isChangeClipListHistory:",isChangeClipListHistory);

        //init page, just add current cliplist to history and
        if (clipListHistory.length === 0) {
            // console.log("init clip history",previousIsChangeClipListHistory,isChangeClipListHistory);
            setClipListHistory([clipList]);
            return;
        }

        if (!isChangeClipListHistory) {
            //only add to history when clip list not changed by undo/redo
            if (previousIsChangeClipListHistory) {
                //user act with previous undo/redo, delete redo history
                //currentClipListIndex
                // console.log("reset clip chg status",previousIsChangeClipListHistory,isChangeClipListHistory);
                setClipListHistory([
                    ...clipListHistory.slice(0, currentClipListIndex + 1),
                    clipList,
                ]);
                setCurrentClipListIndex((prevIndex) => prevIndex + 1);
            } else {
                //user act without previous undo/redo, just add undo history
                if (clipListHistory.length > 0) {
                    //first load of page
                    if (!isEqual(clipListHistory[clipListHistory.length - 1], clipList)) {
                        //do not re-add cliplist
                        if (clipListHistory.length > maxHistory) {
                            //restrict undo history length by delete first element
                            // console.log("replace clip history",previousIsChangeClipListHistory,isChangeClipListHistory);
                            setClipListHistory([...clipListHistory.slice(1), clipList]);
                        } else {
                            // console.log("add clip history",previousIsChangeClipListHistory,isChangeClipListHistory);
                            setClipListHistory([...clipListHistory, clipList]);
                            setCurrentClipListIndex((prevIndex) => prevIndex + 1);
                        }
                    }
                }
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [clipList]);

    useEffect(() => {
        // console.log("history: ",clipListHistory.length,"current: ",currentClipListIndex);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, currentClipListIndex, clipListHistory]);

    useEffect(() => {
        // console.log("isLoading ",isLoading);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, isLoading]);

    // idが存在しない時はエラーページで表示
    if (!Number(timelineId) || isFailedGetTimeline) {
        return <Error />;
    }

    return (
        <>
            <div
                className={styles.root}
                style={{
                    pointerEvents: isCreatingVideo ? "none" : "auto",
                    opacity: isCreatingVideo ? "0.5" : "1",
                }}
            >
                <div className={styles.header}>
                    <div className={styles.headerLeftDiv}>
                        <Link to="/studio/homepage">
                            <ArrowIcon width={26} height={26} />
                        </Link>
                        {/* <img src={BeforeIcon} alt="beforeIcon" className={styles.beforeIcon} />
                        <img
                            src={NextIcon}
                            alt="nextIcon"
                            className={styles.nextIcon}
                            width={9}
                            height={15}
                        /> */}

                        {/* <img src={SearchIcon} alt="SearchIcon" className={styles.searchIcon}/> */}
                    </div>
                    {timeline && timeline.name && (
                        <div className={styles.headerCenterDiv}>{timeline.name}</div>
                    )}
                    <div className={styles.headerRightDiv}>
                        {/* <img
                            className={`${styles.undoIcon} ${(currentClipListIndex > 0 &&!isLoading)? styles.isActive : ""}`}
                            onClick={handleUndoButton}
                            src={UndoIcon}
                            alt="UndoIcon"
                        />
                        <img
                            className={
                                `
                                ${styles.redoIcon}
                                ${(currentClipListIndex < (clipListHistory.length - 1) &&!isLoading) ? styles.isActive : ""}
                                `
                            }
                            onClick={handleRedoButton}
                            src={RedoIcon}
                            alt="RedoIcon"
                        /> */}
                        {/* <div className={styles.keep}>保存</div>
                        <div className={styles.preview}>プレビュー</div> */}
                        <ExportVideo />
                    </div>
                </div>
            </div>
            {/* 素材一覧、動画再生 */}
            <div className={styles.directoryVideo}>
                {/* 左側の素材一覧 */}
                <TimelineDirectory />

                {/* 右側の動画再生 */}
                <TimelineVideoPlayer />
            </div>

            <PuiMessage
                open={showExportSuccessMessage}
                type="success"
                title="書き出し完了しました。"
                duration={3000}
                onClose={closeExportSuccessMsg}
            />
            <PuiMessage
                open={showExportErrorMessage}
                type="error"
                title="書き出し失敗しました。"
                duration={3000}
                onClose={closeExportErrorMsg}
            />

            {isCreatingVideo && (
                <div className={styles.dialog}>
                    <div className={styles.modalRoot}>
                        <div className={styles.timelineModalDiv}>
                            <CircularProgress size={30} style={{ color: "var(--loading-bg)" }} />
                            <div className={styles.isCreatingVideoText}>
                                <PuiTypography>書き出し中です・・・</PuiTypography>
                            </div>
                            <Button
                                className={styles.cancelButton}
                                onClick={handleCancelButton}
                                style={{
                                    color: "var(--white)",
                                    backgroundColor: "#606060",
                                    marginTop: "30px",
                                }}
                            >
                                キャンセル
                            </Button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}
